import { render, staticRenderFns } from "./suitch-sfir.vue?vue&type=template&id=2f947457&"
import script from "./suitch-sfir.vue?vue&type=script&lang=js&"
export * from "./suitch-sfir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports